// extracted by mini-css-extract-plugin
export default {"reactivate":"Success-module__reactivate__LlaWY","text":"Success-module__text__m1jGb"};